var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClips(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Clips"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.9999 3.4C9.49683 3.4 3.3999 9.49693 3.3999 17C3.3999 24.5031 9.49683 30.6 16.9999 30.6C24.503 30.6 30.5999 24.5031 30.5999 17C30.5999 9.49693 24.503 3.4 16.9999 3.4ZM16.9999 4.75988C23.7677 4.75988 29.2399 10.232 29.2399 16.9999C29.2399 23.7678 23.768 29.2399 16.9999 29.2399C10.2321 29.2399 4.7599 23.7678 4.7599 16.9999C4.7599 10.232 10.2318 4.75988 16.9999 4.75988ZM13.2598 10.8799V23.1199L23.4598 16.9999L13.2598 10.8799Z",
    fill: "url(#paint0_linear_7046_15391)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7046_15391",
    x1: 19.9652,
    y1: -5.79769,
    x2: -6.08172,
    y2: 7.62293,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop1",
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop2",
    offset: 1,
    stopColor: "#B6B6B6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClips);
export default __webpack_public_path__ + "static/media/clips.21e13606.svg";
export { ForwardRef as ReactComponent };